// IMPORTS
	import wixData from 'wix-data';
	import {session} from 'wix-storage';
	import wixLocation from 'wix-location';

// CONSTANTS
	const StoreURL = "/our-products", defaultFilter = wixData.filter().eq("show", true)
		
// FUNCTIONS	
 // Areas
	export function areasDropdown_change(event) {
		let area = $w("#areasDropdown").value
		console.log("areasDropdown_change", area);
	 //	Store filters
		// let filter = prefix === "#happ" ? defaultFilter.eq("Happ", true) : defaultFilter.ne("Happ", true) - filter sifferent store strip (happ/toys)
		let filter = area === "כל הארץ" ? defaultFilter : defaultFilter.eq("region", area)
		console.log("filter", filter);
		$w("#storeDataset").setFilter(filter)
	}


 // Stores
	export function storeRepeater_itemReady($item, itemData, index) {
		// let phoneUrl = "tel:+972-" + itemData.Phone.substring(1)
		// $item("#phoneButton").show()
		// $item("#contactName").show()
		// $item("#phoneIcon").show()
		// $item("#phoneIcon").link = phoneUrl
		// $item("#phoneButton").link = phoneUrl
		if (itemData.WhatsApp !== undefined) {
			$item("#whatsappIcon").show()
			// $item("#whatsappIcon").link = "https://api.whatsapp.com/send?phone=972" + itemData.WhatsappNumber
		}
		// $item("#browseStore").onClick(() => browseButton(itemData._id))
	} function browseButton(id) {
		// if (session.getItem("storeID") !== id) session.removeItem("products")	// Clear cart if store was switched
		session.setItem("storeID", id)
		wixLocation.to(StoreURL)
	}